import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumber], [appSignedNumber]',
})
export class NumberDirective implements AfterContentInit {
  private element: HTMLInputElement;

  private signed = false;

  constructor(private el: ElementRef, private control: NgControl, private changeDetectorRef: ChangeDetectorRef) {
    this.element = this.el.nativeElement;
    this.signed = this.element.hasAttribute('appSignedNumber');
  }

  @HostListener('input')
  public onKeyUp(): void {
    this.getFormattedValue();
  }

  ngAfterContentInit(): void {
    this.getFormattedValue();
    this.changeDetectorRef.detectChanges();
  }

  private getFormattedValue() {
    const formControl: AbstractControl | null = this.control.control;

    const inputValue = this.element.value;
    let valueNumber = +inputValue.replace(/[^0-9\.]/g, '');

    // Handle negative numbers and inputValue = '-'.
    if (inputValue.startsWith('-') && this.signed) {
      valueNumber = -valueNumber;
    }

    if (!isNaN(valueNumber)) {
      formControl?.setValue(`${valueNumber.toLocaleString()}${inputValue.endsWith('.') ? '.' : ''}`);
    } else if (this.element.value.length) {
      formControl?.setValue(0);
    }
  }
}
